module.exports = "<a routerLink=\"/client/add\" class=\"btn btn-outline-success btn-block\">\n  <i class=\"fa fa-plus\"></i> New\n</a>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/hassa/Desktop/clientpanel-final/clientpanel_final/src/app/components/sidebar/sidebar.component.html
// module id = ../../../../../src/app/components/sidebar/sidebar.component.html
// module chunks = main